// extracted by mini-css-extract-plugin
export var messageSideLeft = "_iy-1";
export var messageSideRight = "_iy-2";
export var orderLookupBubbleContainer = "_iy-0";
export var submitButton = "_iy-3";